import {
	Pipe,
	PipeTransform,
} from '@angular/core';

@Pipe({
	name: 'commonTwoDigitsNumber',
})
export class CommonTwoDigitsNumberPipe implements PipeTransform {
	transform (num: number, placeholder = '0'): string {
		num = num || 0;

		if (num < 10) {
			return (placeholder + num).slice(-2);
		} else {
			return num.toString(10);
		}
	}
}
